/**
 * DisconnectBankDialog - Confirmation dialog for bank disconnection
 * 
 * Required for Akahu Open Banking transparency
 */
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";
import { Unlink } from "lucide-react";

export function DisconnectBankDialog({ 
  open, 
  onOpenChange, 
  onConfirm, 
  loading = false,
  bankName = "your bank"
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="disconnect-bank-dialog">
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-amber-100 dark:bg-amber-900/30 rounded-lg">
              <Unlink className="w-5 h-5 text-amber-600 dark:text-amber-400" />
            </div>
            <AlertDialogTitle>Disconnect Bank?</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-left">
            Disconnecting will stop new transactions from syncing with ARA Wealth. 
            Existing data will remain unless you delete your account.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="disconnect-cancel-btn">Cancel</AlertDialogCancel>
          <AlertDialogAction 
            onClick={onConfirm}
            disabled={loading}
            className="bg-amber-600 hover:bg-amber-700 text-white"
            data-testid="disconnect-confirm-btn"
          >
            {loading ? "Disconnecting..." : "Disconnect"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default DisconnectBankDialog;
